import Cookies from "js-cookie";
import { isDesktopApp } from "./platform";

// Chromium doesn't persist document.cookie writes for pages loaded over the
// file:// protocol (how the packaged desktop build runs) — so the desktop
// build keeps the jwt in localStorage instead; the web build keeps the cookie.
const JWT_KEY = "jwt";

export const getJwt = () =>
  isDesktopApp ? localStorage.getItem(JWT_KEY) : Cookies.get(JWT_KEY);

export const setJwt = (token) => {
  if (isDesktopApp) {
    localStorage.setItem(JWT_KEY, token);
  } else {
    Cookies.set(JWT_KEY, token, { expires: 1 });
  }
};

export const clearJwt = () => {
  if (isDesktopApp) {
    localStorage.removeItem(JWT_KEY);
  } else {
    Cookies.remove(JWT_KEY);
  }
};
